module.exports = __webpack_public_path__ + "static/media/BOTON WEB_Inst Cuerdas Frotadas.68e28fa2.png";